"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function () {
  var ownKeys = function (o) {
    ownKeys = Object.getOwnPropertyNames || function (o) {
      var ar = [];
      for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
      return ar;
    };
    return ownKeys(o);
  };
  return function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
    __setModuleDefault(result, mod);
    return result;
  };
}();
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeRedirectUrl = exports.setRedirectUrl = exports.getRedirectUrl = exports.getRedirectUrlParam = exports.redirectToAuth = exports.redirectNext = void 0;
const config_1 = __importDefault(require("../../build-babel/auth/client/config"));
const redirect_1 = require("../../build-babel/redirect/redirect");
const validator_1 = require("../../build-babel/redirect/validator");
const redirectUrlStorage = __importStar(require("../../build-babel/redirect/storage"));
const url_1 = require("../../build-babel/redirect/url");
const localhost_1 = require("../../build-babel/redirect/localhost");
const redirectNext = idToken => {
  const envConfig = (0, config_1.default)();
  if (envConfig) {
    const redirectUrl = (0, exports.getRedirectUrl)() || envConfig.homepageUri;
    if (idToken && (0, localhost_1.isLocalhostRedirect)(redirectUrl)) {
      (0, redirect_1.makeRedirectTo)((0, localhost_1.makeLocalhostRedirectUrl)(idToken));
    } else {
      (0, exports.removeRedirectUrl)();
      (0, redirect_1.makeRedirectTo)(redirectUrl);
    }
  }
};
exports.redirectNext = redirectNext;
const redirectToAuth = () => {
  const envConfig = (0, config_1.default)();
  if (envConfig === null || envConfig === void 0 ? void 0 : envConfig.auth.redirectUri) {
    (0, redirect_1.makeRedirectTo)(envConfig.auth.redirectUri);
  } else {
    (0, exports.redirectNext)();
  }
};
exports.redirectToAuth = redirectToAuth;
const getRedirectUrlParam = () => {
  const redirectUrlParam = (0, url_1.getRedirectFromUrl)();
  return redirectUrlParam && (0, validator_1.isAllowedDomain)(redirectUrlParam) ? redirectUrlParam : null;
};
exports.getRedirectUrlParam = getRedirectUrlParam;
const getSavedRedirectUrl = () => {
  const redirectUrl = redirectUrlStorage.get();
  if (!redirectUrl) return null;
  if ((0, validator_1.isAllowedDomain)(redirectUrl)) {
    return redirectUrl;
  } else {
    (0, exports.removeRedirectUrl)();
    return null;
  }
};
const getRedirectUrl = () => (0, exports.getRedirectUrlParam)() || getSavedRedirectUrl();
exports.getRedirectUrl = getRedirectUrl;
const setRedirectUrl = () => {
  const redirectUrl = (0, exports.getRedirectUrlParam)();
  if (redirectUrl && (0, validator_1.isAllowedDomain)(redirectUrl)) {
    redirectUrlStorage.set(redirectUrl);
  }
};
exports.setRedirectUrl = setRedirectUrl;
const removeRedirectUrl = () => {
  redirectUrlStorage.remove();
};
exports.removeRedirectUrl = removeRedirectUrl;
//# sourceMappingURL=index.js.map